import React from 'react';
import { Box } from '@chakra-ui/react';
const ScrollableWrapper = ({ children, ...rest }) => (React.createElement(Box, { "data-testid": "scrollable_wrapper", maxH: "350px", minH: "330px", overflowY: "auto", ...rest }, children));
export default ScrollableWrapper;
